import { Box, Typography } from '@mui/material';
import SignaturePad from 'components/SignaturePad';
import CustomDialogHeader from 'components/CustomDialog/DialogHeader/dialogHeader.cmp';
import CustomDialog from 'components/CustomDialog/customDialog';

const SignaturewModal = ({ open, signature, onClose, onSave }) => {
  return (
    <CustomDialog
      hideActions={true}
      header={
        <CustomDialogHeader onClose={onClose}>
          <Typography fontSize={'20px'} fontWeight={700}>
            Add Your Signature
          </Typography>
        </CustomDialogHeader>
      }
      dialogProps={{
        open: open,
        maxWidth: true,
        onClose: onClose,
        sx: {
          '& .MuiDialog-paper': {
            maxWidth: '600px',
          },
          '& .MuiDialogContent-root': {
            maxWidth: '100%',
            width: '600px',
          },
        },
      }}
    >
      <Box sx={{ p: 3 }}>
        <SignaturePad value={signature} handleSave={onSave} />
      </Box>
    </CustomDialog>
  );
};

export default SignaturewModal;
